import { render } from "./OrderCard.vue?vue&type=template&id=e6a1548a&scoped=true"
import script from "./OrderCard.vue?vue&type=script&lang=js"
export * from "./OrderCard.vue?vue&type=script&lang=js"

import "./OrderCard.vue?vue&type=style&index=0&id=e6a1548a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e6a1548a"

export default script